import CoursePath from '@/models/CoursePath';
import { CourseBoxHeaderSkeleton } from '../skeletons/CourseBoxSkeletons';
import CourseBoxHeaderService from './CourseBoxHeaderService';
export type CourseBoxHeaderProps = {
  coursePath: CoursePath;
  isLoading?: boolean;
};

const CourseBoxHeader = ({
  coursePath,
  isLoading: loading,
}: Partial<CourseBoxHeaderProps>) => {
  if (loading) return <CourseBoxHeaderSkeleton />;
  if (!coursePath) return null;
  return <CourseBoxHeaderService coursePath={coursePath} isLoading={loading} />;
};

export default CourseBoxHeader;
